import React from 'react';
import { css } from 'emotion';
import { palette, space } from '@guardian/src-foundations';
import { body } from '@guardian/src-foundations/typography';
import { SvgAlertRound } from '@guardian/src-icons';
import { YoutubeAtom } from '@guardian/atoms-rendering';
import { trackVideoInteraction } from '@root/src/web/browser/ga/ga';
import { record } from '@root/src/web/browser/ophan/ophan';
import { Caption } from '@root/src/web/components/Caption';
const expiredOverlayStyles = (overrideImage) => css `
	height: 0px;
	position: relative;
	background-image: url(${overrideImage});
	background-size: cover;
	background-position: 49% 49%;
	background-repeat: no-repeat;
	padding-bottom: 56%;
	color: ${palette.neutral[100]};
	background-color: ${palette.neutral[20]};
`;
const expiredTextWrapperStyles = css `
	display: flex;
	flex-direction: row;
	align-items: center;

	padding-top: ${space[4]}px;
	padding-bottom: ${space[4]}px;
	padding-left: ${space[1]}px;
	padding-right: ${space[12]}px;
	color: ${palette.neutral[100]};
	background-color: ${palette.neutral[20]};
`;
const expiredSVGWrapperStyles = css `
	padding-right: ${space[1]}px;
	svg {
		width: ${space[12]}px;
		height: ${space[12]}px;
		fill: ${palette.neutral[100]};
	}
`;
export const YoutubeBlockComponent = ({ id, assetId, mediaTitle, altText, display, design, pillar, hideCaption, overrideImage, posterImage, expired, role, adTargeting, isMainMedia, height = 259, width = 460, duration, origin, }) => {
    const shouldLimitWidth = !isMainMedia &&
        (role === 'showcase' || role === 'supporting' || role === 'immersive');
    if (expired) {
        return (React.createElement("figure", { className: css `
					margin-top: 16px;
					margin-bottom: 16px;
				` },
            React.createElement("div", { className: overrideImage && expiredOverlayStyles(overrideImage) },
                React.createElement("div", { className: expiredTextWrapperStyles },
                    React.createElement("div", { className: expiredSVGWrapperStyles },
                        React.createElement(SvgAlertRound, null)),
                    React.createElement("p", { className: css `
								${body.medium({
                            lineHeight: 'tight',
                        })}
							` }, "This video has been removed. This could be because it launched early, our rights have expired, there was a legal issue, or for another reason."))),
            !hideCaption && (React.createElement(Caption, { display: display, design: design, captionText: mediaTitle || '', pillar: pillar, displayCredit: false, shouldLimitWidth: shouldLimitWidth }))));
    }
    const ophanTracking = (trackingEvent) => {
        if (!id)
            return;
        record({
            video: {
                id: `gu-video-youtube-${id}`,
                eventType: `video:content:${trackingEvent}`,
            },
        });
    };
    const gaTracking = (trackingEvent) => {
        if (!id)
            return;
        trackVideoInteraction({
            trackingEvent,
            elementId: id,
        });
    };
    return (React.createElement("div", { "data-chromatic": "ignore" },
        React.createElement(YoutubeAtom, { assetId: assetId, overrideImage: overrideImage
                ? [
                    {
                        srcSet: [
                            {
                                src: overrideImage,
                                width: 500,
                            },
                        ],
                    },
                ]
                : undefined, posterImage: posterImage
                ? [
                    {
                        srcSet: posterImage.map((img) => ({
                            src: img.url,
                            width: img.width,
                        })),
                    },
                ]
                : undefined, role: role, alt: altText || mediaTitle || '', adTargeting: adTargeting, height: height, width: width, title: mediaTitle, duration: duration, eventEmitters: [ophanTracking, gaTracking], pillar: pillar, origin: process.env.NODE_ENV === 'development' ? '' : origin }),
        !hideCaption && (React.createElement(Caption, { display: display, design: design, captionText: mediaTitle || '', pillar: pillar, displayCredit: false, shouldLimitWidth: shouldLimitWidth }))));
};
